import React, { useRef, useState } from "react";
import { Modal, Form, Row, Col, Switch } from "antd";
import { Button, Input } from "antd";
import Axios from "../../../api/Axios";
import { CloseOutlined, FormOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import DynamicSelect from "../customHooks/DynamicSelect";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const AddEditUsers = ({
  visible,
  onCancel,
  modalData,
  CreateSuccessfull,
  CreateFailed,
  id,
  edit = true, // Assuming this is always true for adding roles
  isContact,
}) => {
  const [loading, setLoading] = useState(false);
  console.log(modalData, edit);
  //console.log(modalData?.code);
  const phoneInputRef = useRef();
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const onFinish2 = async (values) => {
    setLoading(true);
    const payload = {
      ...values,
      status: true,
      organization: id,
      is_contact: isContact || false,
      role: values.role || null,
    };
    const normalizedValues = Object.fromEntries(
      Object.entries(payload).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );

    try {
      await Axios.post(`/customer/users/`, normalizedValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleCancel();
      CreateSuccessfull("Added");
    } catch (err) {
      //console.log(err);
      // CreateFailed("Added");
    } finally {
      setLoading(false);
    }
  };
  const onFinishEdit = async (values) => {
    const payload = {
      ...values,
      status: true,
      organization: id,
      is_contact: isContact || false,
      role: values.role || null,
    };
    try {
      await Axios.put(`/customer/users/?id=${modalData?.id}`, payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleCancel();
      CreateSuccessfull("Edited");
    } catch (err) {
      //console.log(err);
      // CreateFailed("Edited");
    } finally {
      setLoading(false);
    }
  };
  const handleCancel = () => {
    formRef.current.resetFields();
    onCancel();
  };

  const formRef = useRef();
  const loadForm = React.useCallback(() => {
    if (edit && formRef.current) {
      const formValues = {
        user_id: modalData?.employee_id,
        first_name: modalData?.first_name,
        last_name: modalData?.last_name,
        job_title: modalData?.job_title,
        location: modalData?.location?.id || null,
        email: modalData?.email,
        phone_number: modalData?.phone_number,
        access: modalData?.access,
        role: Array.isArray(modalData?.org_role)
          ? modalData.org_role.map((r) => r?.id)
          : modalData?.role?.id
          ? [modalData.role.id]
          : [],
        is_contact: modalData?.is_contact || isContact,
      };
      formRef.current.setFieldsValue(formValues);
    }
  }, [edit, modalData, isContact]);
  useEffect(() => {
    if (modalData && formRef.current) {
      loadForm();
    }
  }, [modalData, loadForm]);
  const [phone, setPhone] = useState("");
  const handlePhoneNumberChange = (value, data, event, formattedValue) => {
    //console.log(data);

    setPhone(value);
  };
  return (
    <Modal
      title={<p className="modal-heading">Manage Users</p>}
      centered
      // open={modalOpen}
      // onOk={() => setModalOpen(false)}
      // onCancel={() => setModalOpen(false)}
      width={900}
      open={visible}
      onCancel={handleCancel}
      footer={[]}
    >
      <Form
        onFinish={edit ? onFinishEdit : onFinish2}
        name="complex-form"
        labelCol={{
          span: 25,
        }}
        wrapperCol={{
          span: 80,
        }}
        ref={formRef}
        layout="vertical"
        style={{
          width: "100%",
          marginTop: "3rem",
        }}
      >
        <div className="group1" style={{ padding: "0rem" }}>
          <div className="antd-test-client" style={{ marginTop: "2rem" }}>
            <Row gutter={20} style={{ marginLeft: "2rem" }}>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">User ID</p>}>
                  <Form.Item
                    name="user_id"
                    noStyle
                    rules={[{ required: true, message: "ID is required" }]}
                  >
                    <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter ID"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">First Name</p>}>
                  <Form.Item
                    name="first_name"
                    noStyle
                    rules={[
                      { required: true, message: "First name is required" },
                    ]}
                  >
                    <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter First name"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">Last Name</p>}>
                  <Form.Item
                    name="last_name"
                    noStyle
                    rules={[
                      { required: true, message: "Last name is required" },
                    ]}
                  >
                    <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter Last name"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">Job Title</p>}>
                  <Form.Item name="job_title" noStyle>
                    <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter Title"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">Email</p>}>
                  <Form.Item
                    name="email"
                    rules={[
                      { required: true, message: "email is required" },
                      {
                        type: "email",
                        message: "Please enter a valid email address",
                        validator: (_, value) => {
                          if (value) {
                            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                            if (emailRegex.test(value)) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("Please enter a valid email address")
                            );
                          }
                          return Promise.reject(
                            new Error("Please enter your email")
                          );
                        },
                      },
                    ]}
                  >
                    <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter user email"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">Phone No.</p>}>
                  <Form.Item noStyle name="phone_number">
                    <PhoneInput
                      // className="my-form-input"
                      ref={phoneInputRef}
                      placeholder="Enter your Phone No."
                      country="us"
                      value={phone}
                      // style={{ width: "27rem" }}
                      onChange={handlePhoneNumberChange}
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <DynamicSelect
                  name="role"
                  label="User Role"
                  url={`customer/userroles/${id}/`}
                  initialValue={modalData?.role}
                  takeFromInitial={true}
                  multiple={true}
                />
              </Col>
              <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                <Form.Item label={<p className="my-form-lables">Access</p>}>
                  <Form.Item
                    name="access"
                    // valuePropName="checked"
                  >
                    <Switch checked={modalData?.access} />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                <Form.Item label={<p className="my-form-lables">Is Contact</p>}>
                  <Form.Item
                    name="is_contact"
                    // valuePropName="checked"
                  >
                    <Switch
                      checked={modalData?.is_contact || isContact}
                      disabled
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
            </Row>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            height: "2rem",
            marginTop: "1rem",
          }}
        >
          <Form.Item style={{ marginRight: "1rem" }}>
            <Button key="back" onClick={handleCancel}>
              <CloseOutlined />
              Cancel
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              style={{
                background: "#f58029",
                // fontWeight: "600",
              }}
              className="save-update-btn"
            >
              {edit ? "Update" : "Save"}
              <FormOutlined />
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default AddEditUsers;
